import { useQuery } from "@tanstack/react-query"
import { getAccountDashboard } from "api/accountReportApi"

export const ACCOUNT_DASHBOARD_QUERY_KEY = "account-dashboard"

export const useAccountDashboard = (enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_DASHBOARD_QUERY_KEY],
    queryFn: getAccountDashboard,
    staleTime: 1000 * 60 * 5,
    enabled,
  })
}
